import { createAsyncThunk } from '@reduxjs/toolkit'
import { ResolveUrl } from 'features/firebase-app'
import { getBearerToken } from '../../application/application-slice'

export const accept_player_invite = createAsyncThunk<any, any, any>(
  'auto/accept/player/invite',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/accept/player/invite'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const get_player_invites = createAsyncThunk<any, any, any>(
  'auto/get/player/invites',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/get/player/invites'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)

export const invite_player_to_playwatch = createAsyncThunk<any, any, any>(
  'auto/invite/player',
  async (params, apiThunk: { getState: any }) => {
    let { getState } = apiThunk
    let state = getState()
    let bearToken = getBearerToken(state)
    if (bearToken) {
      try {
        let response = await fetch(ResolveUrl('auto/invite/player'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${bearToken}`,
            'Access-Control-Allow-Origin': '*',
          },
          body: JSON.stringify(params),
        })
        let res = await response.json()
        if (params && params.callback) {
          params.callback(true, res)
        }

        return res
      } catch (e) {
        if (params && params.callback) {
          params.callback(false, e)
        }
      }
    } else {
      if (params && params.callback) {
        params.callback(false)
      }
      throw 'not signed in'
    }
  },
)
